import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { NavigationHeader } from 'components/NavigationHeader';
import { PageScrollView } from 'components/Page';
import React from 'react';
import { Txt } from 'components/Txt';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from 'components/Card';
import { TextAreaField } from 'components/Field/TextAreaField/TextAreaField';
import {
  doEngageScheduledVisitCancel,
  NAVIGATE_MODAL_BACK,
} from 'store/actions';
import { theme } from 'lib/theme';
import { CardRow } from 'components/CardRow';
import {
  selectEngageScheduledVisitTemplatesData,
  selectEngageScheduledVisitTemplatesLoading,
} from 'store/remote/engageSelectors';
import { State } from 'store/types';
import { View } from 'react-native';
import { Icon, ICONS } from 'components/Icon';

export const EngageCancelScheduledVisitModal: React.FC<
  ModalScreenProps<ModalScreens.EngageCancelScheduledVisit>
> = (props) => {
  const { propertyId, pageKey, scheduledVisitId } = props.route.params;
  const dispatch = useDispatch();

  const [note, setNote] = React.useState('');
  const [isPreviewOpen, setIsPreviewOpen] = React.useState(false);

  const templates = useSelector((state: State) =>
    selectEngageScheduledVisitTemplatesData(state, pageKey),
  );
  const templatesStatus = useSelector((state: State) =>
    selectEngageScheduledVisitTemplatesLoading(state, pageKey),
  );

  const handleClose = React.useCallback(() => {
    dispatch(NAVIGATE_MODAL_BACK());
  }, [dispatch]);

  const handleSave = () =>
    dispatch(
      doEngageScheduledVisitCancel({
        propertyId,
        pageKey,
        scheduledVisitId: scheduledVisitId,
        cancelledReason: note.trim(),
      }),
    );

  return (
    <PageScrollView
      header={
        <NavigationHeader
          onPressCancelButton={handleClose}
          onPressSaveButton={note.trim() ? handleSave : null}
          saveButtonText="Confirm"
          heading="Cancel Scheduled Visit"
        />
      }
    >
      <Card
        label="Reason"
        explanation="Please provide a reason for cancellation. This will be included in the cancellation email to contacts."
      >
        <TextAreaField
          // Blank as per ticket
          placeholder=""
          onChange={setNote}
          value={note}
          onEsc={handleClose}
          maxLength={1000}
        />
      </Card>

      {templatesStatus === 'loaded' &&
        templates.map((template) => {
          if (template.name !== 'Cancellation') {
            return null;
          }

          return (
            <Card key={template.id} label="Message Timeline">
              <CardRow
                icon={ICONS.ChevronRightLight}
                iconSize={16}
                iconStyle={{
                  transform: [{ rotate: isPreviewOpen ? '90deg' : '0deg' }],
                }}
                onPress={() => setIsPreviewOpen((prev) => !prev)}
              >
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <Txt size="normal" weight="medium" style={{ flex: 1 }}>
                    {template.name}
                  </Txt>
                  <View
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: theme.paddingHorizontalHalf,
                    }}
                  >
                    <Icon
                      source={ICONS.ClockLight}
                      color={theme.colors.fieldValueText}
                      size={16}
                    />
                    <Txt
                      size="small"
                      weight="medium"
                      style={{ color: theme.colors.fieldValueText }}
                    >
                      Immediately
                    </Txt>
                  </View>
                </View>
                <Txt style={{ marginTop: 2 }} size="xsmall">
                  {template.description}
                </Txt>
              </CardRow>
              {isPreviewOpen && (
                <CardRow>
                  <Txt weight="medium" size="small">
                    Subject: {template.subject}
                  </Txt>
                  <Txt size="small">
                    {note
                      ? template.body.replace(
                          '[cancellationReason]',
                          note.trim(),
                        )
                      : template.body}
                  </Txt>
                </CardRow>
              )}
            </Card>
          );
        })}
    </PageScrollView>
  );
};
